module.exports = __webpack_public_path__ + "img/delete.c3cf2b28.svg";